import { render, staticRenderFns } from "./v-pill-remove-popup.vue?vue&type=template&id=664811ce&scoped=true"
import script from "./v-pill-remove-popup.vue?vue&type=script&lang=js"
export * from "./v-pill-remove-popup.vue?vue&type=script&lang=js"
import style0 from "./v-pill-remove-popup.vue?vue&type=style&index=0&id=664811ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664811ce",
  null
  
)

export default component.exports